<script>
  import NauiInput from "../../../lib/naui/atoms/NauiInput.svelte";
  import NauiTextarea from "../../../lib/naui/atoms/NauiTextarea.svelte";
  import "../../../../static/front/css/lib/astillero/_formAud.css";
  import { writable } from "svelte/store";
  import { createEventDispatcher } from "svelte";
  import { onMount } from "svelte";
  import {maxLenghtInput} from "../../../lib/utils/index";
  
  export let all_tamano_muestra;
  export let data;

  const dispatch = createEventDispatcher();
  let empaqueEstado = data.empaque_estado; 
  
  let empaqueData = {
    empaque_estado: data.empaque_estado,
    empaque_total_cajas: data.empaque_total_cajas,
    empaque_descripcion_defectos: data.empaque_descripcion_defectos,
    empaque_codigos_cajas_auditadas: data.empaque_codigos_cajas_auditadas,
  };

  function actualizarDatos() {
    dispatch("update", { label: "Empaque", data: { ...empaqueData } });
  }

  $: {

    empaqueData.empaque_estado = empaqueEstado;
    actualizarDatos();
  }

  onMount(() => {
    actualizarDatos();
  });
</script>

<div class="containerMain">
  <div class="containerMainInt">
    <div class="muestra-content">
      <div>
        <NauiInput
          class='{$all_tamano_muestra <1 || !$all_tamano_muestra ? "red-border" : ""}'
          label="Tamaño de Muestra"
          type="number"
          bind:value={$all_tamano_muestra}
          on:input={(e)=>{
            $all_tamano_muestra = maxLenghtInput(e, 9);
            actualizarDatos();
          }}
        />
        {#if $all_tamano_muestra <1 || !$all_tamano_muestra}
          <p class="error-message">Este campo es obligatorio</p>
        {/if}
      </div>
      <NauiInput label="A" type="text" value="0" isDisabled />
      <NauiInput label="R" type="text" value="0" isDisabled />

      <label for="aEmpaq_{data.id}">A</label>
      <input
        type="radio"
        name="empaqueEstado_{data.id}"
        id="aEmpaq_{data.id}"
        value={true}
        bind:group={empaqueEstado}
      />
      <label for="rEmpaq_{data.id}" >R</label>
      <input
        type="radio"
        name="empaqueEstado_{data.id}"
        id="rEmpaq_{data.id}"
        value={false}
        bind:group={empaqueEstado}
      />
    </div>

    <div class="description">
      <p>DESCRIPCIÓN DE DEFECTOS:</p>
      <NauiTextarea
        label=""
        class="textArea"
        bind:value={empaqueData.empaque_descripcion_defectos}
        on:input={(e) => { 
          empaqueData.empaque_descripcion_defectos = maxLenghtInput(e, 2000);
          actualizarDatos();
        }}
      />
    </div>

    <div class="totals">
      <NauiInput
        class="item-total"
        label="Total Cajas"
        type="number"
        min=0
        bind:value={empaqueData.empaque_total_cajas}
        on:input={(e)=>{
          empaqueData.empaque_total_cajas = maxLenghtInput(e, 9);
          actualizarDatos();
        }}
      />
      <NauiInput
        id="raizTotalCajas"
        class="item-total"
        label="Raíz + 1 Caja"
        type="number"
        value={empaqueData.empaque_total_cajas > 0 ? Math.floor(Math.sqrt(empaqueData.empaque_total_cajas)) + 1 : "0"}
        isDisabled
      />
    </div>

    <div class="code">
      <p>CÓDIGOS DE CAJAS AUDITADAS:</p>
      <NauiTextarea
        label=""
        class="textArea"
        bind:value={empaqueData.empaque_codigos_cajas_auditadas}
        on:input={(e) => { 
          empaqueData.empaque_codigos_cajas_auditadas = maxLenghtInput(e, 2000);
          actualizarDatos();
        }}
      />
    </div>
  </div>
</div>

<style>
  .muestra-content {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .description {
    width: 100%;
    justify-content: center;
    align-items: center;
  }

  :global(.textArea .naui-field) {
    width: 100%;
  }

  :global(.textArea .naui-field-back) {
    width: 100%;
  }

  :global(.textArea .naui-input) {
    width: 100%;
    padding: 0.75rem;
    min-height: 50px;
    height: auto;
    resize: none;
    background-color: white;
  }

  .description p {
    justify-content: center;
    align-items: center;
    font-size: 12px;
    color: #888;
  }

  .totals {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  :global(.item-total.naui-field) {
    width: 49%;
  }

  .code p {
    justify-content: center;
    align-items: center;
    font-size: 12px;
    color: #888;
  }
  
  :global(.red-border.naui-field input label) {
    border: 1px solid #ff5a5f;
  }
  :global(.red-border.naui-field.active label) {
    color: red;
  }

</style>
